"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfListingActivityLogDto = instanceOfListingActivityLogDto;
exports.ListingActivityLogDtoFromJSON = ListingActivityLogDtoFromJSON;
exports.ListingActivityLogDtoFromJSONTyped = ListingActivityLogDtoFromJSONTyped;
exports.ListingActivityLogDtoToJSON = ListingActivityLogDtoToJSON;
exports.ListingActivityLogDtoToJSONTyped = ListingActivityLogDtoToJSONTyped;
/**
 * Check if a given object implements the ListingActivityLogDto interface.
 */
function instanceOfListingActivityLogDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('activityType' in value) || value['activityType'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function ListingActivityLogDtoFromJSON(json) {
    return ListingActivityLogDtoFromJSONTyped(json, false);
}
function ListingActivityLogDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'activityType': json['activityType'],
        'message': json['message'],
        'createdAt': (new Date(json['createdAt'])),
    };
}
function ListingActivityLogDtoToJSON(json) {
    return ListingActivityLogDtoToJSONTyped(json, false);
}
function ListingActivityLogDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'activityType': value['activityType'],
        'message': value['message'],
        'createdAt': value['createdAt'].toISOString(),
    };
}
